const rectalMass = [

    {
    label:"Size (cm)",
    controlType:"text",
    options:[]
    },

    {label:"Involving",
    controlType:"checkbox group",
    options:["Perianal skin", "Anal Canal", "Low rectal", "High rectal"]
    },

    { label:"Type of lesion",
    controlType:"radio button",
    options:["Mass", "Ulcer", "Ulcerated mass"]
    },


    { label:"Consistency:",
    controlType:"radio button",
    options:["Hard", "Soft"]
    },

    {label:"Texture:",
    controlType:"radio button",
    options:["Smooth", "Irregular"]
    },

    {label:"Pain:",
    controlType:"radio button",
    options:["Painful", "Painless"]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }

]



export default rectalMass